// extracted by mini-css-extract-plugin
export var backupIcon = "_oo-1";
export var image = "_oo-0";